<section class="loaderContainer" *ngIf="visible" [class.finished]="isFinished">
    <div class="loaderMainWrapper">
        <div class="loaderImgWrapper">
            <img src="assets/images/infinthra-bluetext-logo.webp" alt="infithra-logo"/>
        </div>
        <div class="loaderBarContainer">
            <div class="loaderBarFill"></div>
        </div>
    </div>
</section>